export default __webpack_public_path__ + "static/1088-e735385261dd73db8f4905d57a25b53a.gif";